import { Injectable, Signal, inject } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { GalleryState } from '../reducers/gallery.reducer';
import { selectGalleryItems, selectWithThumbnails } from '../selectors';
import { GalleryItem } from '../interfaces';
import { galleryActions } from '../actions';

@Injectable()
export class GalleryFacade {
  private readonly store: Store<GalleryState> = inject(Store);

  public selectItems(): Signal<GalleryItem[]> {
    return this.store.selectSignal(selectGalleryItems);
  }

  public selectWithThumbnails(): Signal<boolean> {
    return this.store.selectSignal(selectWithThumbnails);
  }

  public setItems(items: Array<GalleryItem>): void {
    this.store.dispatch(galleryActions.setItems({ items }));
  }

  public clearStore(): void {
    this.store.dispatch(galleryActions.clearStore());
  }

  public loadDetail(action: Action): void {
    this.store.dispatch(action);
  }

  public updateState(state: Partial<GalleryState>): void {
    this.store.dispatch(galleryActions.updateState(state));
  }
}
